export enum CreditCardIssuerDTO {
    Amex = "Amex",
    DinersClub = "DinersClub",
    Elo = "Elo",
    HiperCard = "HiperCard",
    Mastercard = "Mastercard",
    Visa = "Visa"
}
